import React from "react";
import PropTypes from "prop-types";
import submit from "submit-form";

import { getDateToDisplay } from "../../../../utils/nutrition-helpers";
import SvgIcon from "../../../../parts/SvgIcon";
import { calculateWeeksWithDays } from "../../../../utils/date-helpers";

const ExistingPlans = (
  { nutritionPlans, handleChangeActivePlan, activePlanId },
  { locals }
) => {
  const clientWord = locals.activeUser.referAsClients ? "clients" : "athletes";
  const deleteNutritionPlan = (e, _id) => {
    e.preventDefault();
    const proxyAthlete = locals.query.athlete;

    submit(
      `/actions/nutrition/delete-nutrition-plan/${_id}?proxyAthlete=${proxyAthlete}`,
      {
        method: "GET",
      }
    );
  };

  /**
   * Function to create a meal plan
   * @param {*} e
   */
  const handleCreateMealPlan = (e, plan) => {
    e.preventDefault();
    const { activeUserToRequest, query } = locals;
    const { athlete } = query;
    const { utcStartDate, utcEndDate, userId, _id: nutritionPlanId } = plan;
    const coachId = activeUserToRequest._id;
    const weeks = calculateWeeksWithDays(utcStartDate, utcEndDate);

    const body = {
      utcStartDate,
      utcEndDate,
      published: false,
      athleteId: userId,
      type: "plan",
      coachId,
      weeks,
      nutritionPlanId,
    };
    submit(`/actions/meal-planner/create-meal-plan?proxyAthlete=${athlete}`, {
      method: "POST",
      body,
    });
  };

  return (
    <div className="Nutrition-Plans">
      <div className="plans-head">
        <div>
          <p className="plans-head-title s1">Active Plan</p>
          <p className="p4">
            Create nutrition plans for your {clientWord} and share with them
          </p>
        </div>
        <a
          role="button"
          data-button-type="primary"
          data-icon
          href={`/actions/refresh?modal[type]=create-nutrition-plan`}
        >
          <img src="/img/new-icons/add.svg" alt="plus icon" />
          Create new plan
        </a>
      </div>
      <div className="nutrition-plans-bs">
        {nutritionPlans.map((plan) => {
          const {
            _id,
            utcStartDate,
            utcEndDate,
            calories,
            proteins,
            carbs,
            fats,
            fibers,
            restDay,
            mealPlan: {
              _id: mealPlanId = null,
              published: publishedMealPlan = null,
            } = {},
          } = plan;

          const mealPlanText = !mealPlanId
            ? "Meal Plan"
            : publishedMealPlan
            ? "Published"
            : "Draft";
          const mealPlanIcon = !mealPlanId
            ? "add"
            : publishedMealPlan
            ? "tick-gradient"
            : "info-circle";

          const active = _id === activePlanId;
          return (
            <div className="nutrition-plan-row-item" key={_id}>
              <button
                className={
                  active ? "nutrition-plan-info-active" : "nutrition-plan-info"
                }
                onClick={() => {
                  handleChangeActivePlan(_id);
                }}
              >
                <span className={active ? "active" : ""}>
                  {getDateToDisplay(utcStartDate)} -{" "}
                  {getDateToDisplay(utcEndDate)}
                </span>
                {!!restDay ? (
                  <div className="rest-day-plan">
                    <div className="rest-day-plan-stats">
                      <span>Training Day:</span>
                      <div className="plan-info">
                        kCal {calories} | P {Math.round(proteins)}g | C{" "}
                        {Math.round(carbs)}g | F {Math.round(fats)}g
                        {fibers > 0 ? ` | Fib ${Math.round(fibers)}g` : ""}
                      </div>
                    </div>
                    <div className="rest-day-plan-stats">
                      <span>Rest Day:</span>
                      <div className="plan-info">
                        kCal {restDay.calories} | P{" "}
                        {Math.round(restDay.proteins)}g | C{" "}
                        {Math.round(restDay.carbs)}g | F{" "}
                        {Math.round(restDay.fats)}g
                        {restDay.fibers > 0
                          ? ` | Fib ${Math.round(restDay.fibers)}g`
                          : ""}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="plan-info">
                    kCal {calories} | P {Math.round(proteins)}g | C{" "}
                    {Math.round(carbs)}g | F {Math.round(fats)}g
                    {fibers > 0 ? ` | Fib ${Math.round(fibers)}g` : ""}
                  </div>
                )}
              </button>
              <div className="plan-controls">
                <a
                  className="copy"
                  href={`/actions/refresh?modal[type]=create-nutrition-plan&plan=${_id}&copy=${true}`}
                >
                  <SvgIcon src="/img/new-icons/duplicate.svg" alt="copy" />
                </a>
                <a
                  className="edit"
                  href={`/actions/refresh?modal[type]=create-nutrition-plan&plan=${_id}`}
                >
                  <SvgIcon
                    className="icon-only-white"
                    src="/img/new-icons/edit-pencil.svg"
                    alt="edit"
                  />
                </a>
                <a
                  className="delete"
                  href="#"
                  onClick={(e) => deleteNutritionPlan(e, _id)}
                >
                  <SvgIcon
                    src="/img/new-icons/red-trash.svg"
                    alt="delete"
                    noFilterOnLight={true}
                  />
                </a>
                <a
                  className="meal-plan"
                  {...(mealPlanId
                    ? {
                        href: `/actions/refresh?section=meal-planner&plan=${_id}&mealPlan=${mealPlanId}`,
                      }
                    : {
                        onClick: (e) => {
                          handleCreateMealPlan(e, plan);
                        },
                      })}
                >
                  <SvgIcon
                    src={`/img/new-icons/${mealPlanIcon}.svg`}
                    alt="icon"
                    noFilterOnLight={mealPlanIcon !== "add"}
                  />
                  <span>{mealPlanText}</span>
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

ExistingPlans.contextTypes = { locals: PropTypes.object };

export default ExistingPlans;
